<template>
  <div class="loginPage">
    <!-- header start -->
    <van-nav-bar 
      title="找回密码"
      class="mynavbar" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <!-- header end -->
    <img src="@/assets/images/login/register.jpg" class="loginBg">

    <div class="block pwd-block">
      <div>
        <div class="field-item">
          <div class="hd"><div class="label">账号</div></div>
          <div class="bd"><van-field v-model="input.phone" placeholder="大陆手机号" /></div>
        </div>
        <div class="field-item">
          <div class="hd"><div class="label">验证码</div></div>
          <div class="bd"><van-field type="number" v-model="input.code" placeholder="请输入下图中的字符" /></div>
        </div>
        <div class="field-item">
          <div class="" @click="refreshCode">
            <!-- <img src="https://img.yzcdn.cn/vant/cat.jpeg" class="codePic"> -->
            <SIdentify :identifyCode="code" ></SIdentify>
          </div>
           
          <span class="changeCode" @click="refreshCode">换一换</span>
        </div>
        <div class="btn-area">
          <van-button round  class="loginbtn" @click="goFindPwd">确定</van-button>
          <!-- to="/FindPwd" -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Toast } from 'vant';
import SIdentify from "../../components/login/identify";
  export default {
    data() {
      return {
        code:"",
        input:{
          code:"",
          phone:"",
        }
      }
    }, 
    components: {
      SIdentify: SIdentify
    },
    methods :{
      onClickLeft() {
        this.$router.go(-1)
      },
      init(){
        this.refreshCode()
      },
      refreshCode(){
        var that = this;
        this.$store.dispatch({type:"GetRandomNum"}).then(res => {
          that.code = "";
          if(res.Result.IsSuccess){
            that.code = res.Result.Message;
          }
        }, err => {})
      },
      goFindPwd(){
        var that = this;
        var regPhone = /^1[0-9]{10}$/;
        if (that.input.phone == "") {
            Toast("手机号码不能空！");
            return false;
        } else if (!regPhone.test(that.input.phone)) {
            Toast("手机号码不正确，请核对后再输入！");
            return false;
        }
        if (that.input.code == "") {
            Toast("验证码不能为空！");
            return false;
        }
        if (that.input.code != that.code) {
            Toast("验证码不正确！");
            return false;
        }
        that.$router.replace({
            name : 'FindPwd',  
            params: {   
                phone: that.input.phone,
            }  
        }) 
      }
    },
    created(){
      this.init()
    }
  }
</script>

<style scoped>
.pwd-block{
  margin-top: 20%;
}
.changeCode{
  margin-left: 20px;
  padding: 10px;
  font-size: 12px;
  color: orange;
}
.codePic{
  display: block;
  width: 64px;
  height: 28px;
}
</style>
